import axios from './axios';

export const getAll = async () => {
  const contentPackages = (await axios.get(`/content_packages`)).data;
  return contentPackages;
};
